/* eslint-disable @next/next/no-img-element */
//components
import {
  Breadcrumb,
  BreadcrumbLink,
  Grad,
} from '@/containers-ai/SectionHeading';
import { PillLink } from '@/containers-ai/Buttons';

//styles
import {
  HeroSection,
  HeroBg,
  HeroVisual,
  HeroBgFade,
  HeroInner,
  HeroTitle,
  HeroDescription,
  HeroMetric,
  HeroMetricValue,
  HeroMetricText,
  HeroMetricLabel,
  HeroMetricSource,
  HeroCta,
} from './Hero.styles';

export function Hero({
  slug,
  title,
  description,
  metric,
  metricLabel,
  metricSource,
}) {
  return (
    <HeroSection id="top">
      <HeroBg>
        <HeroVisual
          src={`/images/ai/agents/${slug}/hero-visual.webp`}
          srcSet={`/images/ai/agents/${slug}/hero-visual-sm.webp 640w, /images/ai/agents/${slug}/hero-visual-md.webp 960w, /images/ai/agents/${slug}/hero-visual.webp 1920w`}
          sizes="100vw"
          fetchpriority="high"
          alt=""
          aria-hidden="true"
        />
        <HeroBgFade />
      </HeroBg>
      <HeroInner>
        <Breadcrumb>
          <BreadcrumbLink href="/">LOADSMART</BreadcrumbLink>
          <span>/</span>
          <BreadcrumbLink href="/ai/">LOADSMART AI</BreadcrumbLink>
          <span>/</span>
          <b>{title.toUpperCase()}</b>
        </Breadcrumb>
        <HeroTitle>
          Meet the AI Agents: <br /> <Grad>{title}</Grad>
        </HeroTitle>
        <HeroDescription>{description}</HeroDescription>
        {metric && (
          <HeroMetric>
            <HeroMetricValue>
              <Grad>{metric}</Grad>
            </HeroMetricValue>
            <HeroMetricText>
              <HeroMetricLabel>{metricLabel}</HeroMetricLabel>
              {metricSource && (
                <HeroMetricSource>{metricSource}</HeroMetricSource>
              )}
            </HeroMetricText>
          </HeroMetric>
        )}
        <HeroCta>
          <PillLink href="/contact/#contact-form" className="qlf-btn-1">
            Book a demo &#8594;
          </PillLink>
        </HeroCta>
      </HeroInner>
    </HeroSection>
  );
}
